"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() {}
var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop,
  keys: [],
  getAllKeys: noop
};
function hasStorage(storageType) {
  if (typeof self !== 'object' || !(storageType in self)) {
    return false;
  }
  try {
    var storage = self[storageType];
    var testKey = "reduxjs-toolkit-persist ".concat(storageType, " test");
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.warn("reduxjs-toolkit-persist ".concat(storageType, " test failed, persistence will be disabled."));
    return false;
  }
  return true;
}
function getStorage(type) {
  var storageType = "".concat(type, "Storage");
  if (hasStorage(storageType)) return self[storageType];else {
    if (process.env.NODE_ENV !== 'production') {
      console.error("reduxjs-toolkit-persist failed to create sync storage. falling back to noop storage.");
    }
    return noopStorage;
  }
}
exports.default = getStorage;